export const Footer = () => {

    const currentYear = new Date().getFullYear();

    return (
        <footer className="py-2 text-center">
            <p>© {currentYear} feito com ❤ por <b>leonardoanthony</b></p>
        </footer>
    )
}